import type { ReactNode } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation';

const Title = styled.h2`
  margin: 0;
  font: inherit;
`;

// Only a plain-text title becomes the heading: titles with their own markup (icon plus text, a
// caller's own heading, the close-only null) render untouched, so nothing moves.
export const HeaderTitle = ({ children }: { children: ReactNode }) =>
  typeof children === 'string' && children ? <Title>{children}</Title> : children;

export const useCloseLabel = (closeLabel?: string) => {
  const { t } = useTranslation();
  return closeLabel || t('vacation.select.details.close') || 'Close';
};
